module.exports = __webpack_public_path__ + "static/media/sprinkler.990a853e.svg";